import { clsx } from 'clsx'
import { type FC, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { CircularProgress } from 'base-ui'

import { CallSchedulingToolIframe } from '../../../call-scheduling-tool'

export const DirectContactCallSchedulingDialogContent: FC = () => {
  const [hasIframeLoaded, setHasIframeLoaded] = useState(false)

  return (
    <div className="relative flex flex-col">
      <p className="text-m tablet:mb-10 tablet:ml-5">
        <FormattedMessage id="contact.callSchedulingSection.description" />
      </p>
      <div
        className={clsx(
          hasIframeLoaded ? 'hidden' : 'block',
          'absolute flex size-full items-center justify-center transition-opacity',
        )}
      >
        <CircularProgress className="shrink-0 py-16 text-4xl text-dark-brand" />
      </div>
      <CallSchedulingToolIframe
        onIframeLoad={() => {
          setHasIframeLoaded(true)
        }}
      />
    </div>
  )
}
